import axios from 'axios';

const REQUEST_CANCELED = 'REQUEST_CANCELED';

export const cancelableAction = (actionCreator, action) => {
  if (actionCreator.request) actionCreator.request.cancel();
  const newActionCreator = actionCreator;

  newActionCreator.request = axios.CancelToken.source();

  const cancelToken = actionCreator.request.token;
  const cancelable = promise => {
    const newPromise = promise;

    newPromise.__inProcess = actionCreator.request;
    newPromise.__cancel = actionCreator.request.cancel;

    return promise;
  };

  const isCanceled = axios.isCancel;

  return action.bind(null, { cancelToken, cancelable, isCanceled });
};

export const cancelRequest = (promise = {}) => {
  if (promise.__inProcess && promise.__cancel) {
    promise.__cancel();
  }

  return { type: REQUEST_CANCELED };
};
